<template>
  <!-- 项目案例 -->
  <div class="cases">
    <basepanel>
      <div class="outer-box">
        <!-- pc端，大屏端 -->
        <div v-if="!phoneshow" class="inner-box">
          <!-- 左侧导航条 -->
          <el-menu
            :default-active="activeIndex"
            class="el-menu-vertical"
            @select="handleSelect"
            @open="handle"
            @close="handle"
          >
            <el-submenu v-for="(val, i) in categoryLists" :key="i" :index="(i + 1).toString()">
              <!-- <span
                :class="{ side: true, 'side-active': activeIndex == (i + 1) }"
              ></span>-->
              <template slot="title">
                <span :class="{ side: true, 'side-active': subMenuSideIndex == i }"></span>
                {{ val.categoryName }}
                <!-- {{ val.title }} -->
              </template>
              <template v-if="val.lists && val.lists.length > 0">
                <el-menu-item
                  v-for="(per, ind) in val.lists"
                  :key="ind"
                  :index="i + 1 + '-' + (ind + 1)"
                >{{ per.title }}</el-menu-item>
              </template>
            </el-submenu>
          </el-menu>
          <div class="all-modules">
            <div id="dplayer"></div>
            <div class="explain" v-if="this.select.data">{{ this.select.data.explain }}</div>
          </div>
        </div>

        <!-- 手机端 -->
        <div v-else class="phone-box">
          <el-tabs v-model="activeInd" class="horizontal-tabs">
            <el-tab-pane
              v-for="(val, index) in categoryLists"
              :key="index"
              :label="val.categoryName"
              :name="index.toString()"
            >
              <div class="categoryLists">
                <div
                  class="per-category"
                  v-for="(per, i) in val.lists"
                  :key="i"
                  @click="goto(per.id,i)"
                >
                  <div class="picbox">
                    <img :src="per.defineUrl" alt />
                  </div>
                  <p style="text-align: justify;">
                    {{ per.title }}
                    <i class="el-icon-right"></i>
                  </p>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </basepanel>
  </div>
</template>

<script>
import local from "../utils/local";
import basepanel from "../components/BasePanel";
import {
  // listPublishableCategoryInfo,
  listNextWithFilter,
  listFileInfoByDocumentId,
  listPublishableCategoryAll
} from "../api/index";
import DPlayer from "dplayer";
export default {
  name: "cases",
  components: { basepanel },
  data() {
    return {
      activeIndex: "1-1",
      activeInd: "0",
      id: this.$map.casescategoryId,
      catlist: [
        require("../assets/video/city.mp4"),
        require("../assets/video/yl.mp4"),
        require("../assets/video/coummit.mp4")
      ],
      categoryLists: [],
      select: {},
      selectLevel1: "",
      selectLevel2: "",
      videoUrl: "",
      subMenuSideIndex: "",
      screenWidth: document.body.clientWidth
    };
  },
  computed: {
    phoneshow: function() {
      return this.screenWidth <= 768 ? true : false;
    }
  },

  methods: {
    goto(id, i) {
      let caseExplain = "";
      local.set("prePath", this.$route.name);
      // this.$router.push("/detail/" + id);
      for (let i of this.categoryLists[0].lists) {
        if (id.indexOf(i.id) != -1) {
          caseExplain = i.data.explain;
        }
      }
      let explainInfo = {
          caseExplain: caseExplain,
          caseIndex: i
      }
      local.set("explainInfo",explainInfo)
      this.$router.push({
        path: "/detail/" + i,
      });
    },
    handleSelect(key) {
      this.activeIndex = key;
      if (key.indexOf("-") > -1) {
        let i1 = key.split("-")[0] - 1;
        let i2 = key.split("-")[1] - 1;
        this.selectLevel1 = i1;
        this.selectLevel2 = i2;
        this.select = this.categoryLists[i1].lists[i2];
        this.getFileInfo(this.select.id);
        this.subMenuSideIndex = i1;
      }
      this.videoUrl = this.catlist[this.selectLevel2];
    },
    handle(index) {
      this.subMenuSideIndex = index - 1;
    },
    // 获取视频附件
    async getFileInfo(id) {
      let send = {
        url: {
          id,
           needData:true
        }
      };
      let res = await listFileInfoByDocumentId(send);
      if (res.type == "success") {
        // 附件存在，且为视频格式时播放视频
        if (
          res.data.length > 0 &&
          res.data[0].type &&
          res.data[0].type.indexOf("video") > -1
        ) {
          // this.videoUrl = this.$srcUrl + res.data[0].id + "/stream";
          let options = {
            container: document.getElementById("dplayer"),
            autoplay: true,
            video: {
              // url: this.videoUrl
              url: this.videoUrl
            }
          };
          const dp = new DPlayer(options);
          dp.play();
        }
      } else {
        console.log(res.msg);
      }
    },
    async getCategory() {
      let send = {
        url: {
          id: this.$map.casescategoryId,
          count:0
        }
      };
      let res = await listPublishableCategoryAll(send);
      if (res.type == "success") {
        this.categoryLists = res.data;
        res.data.map((data, index) => {
            this.getLists(data.id, index);
          });
      } else {
        console.log(res.msg);
      }
    },
    async getLists(id,ind) {
      let send = {
        url: {
          page: 1,
          size: 30
        },
        data: {
          categoryIdList: [id],
          needData: true
        }
      };
      let res = await listNextWithFilter(send);
      if (res.type == "success") {
        let list = res.data;
        list.map(val => {
          this.$set(val, "defineUrl", this.$srcHandle(val.data.imageclipper));
        });
        this.$set(this.categoryLists[ind], "lists", list);
        this.select = this.categoryLists[ind].lists[0];
        this.getFileInfo(this.select.id);
      } else {
        console.log(res.msg);
      }
    }
  },
  watch: {
    screenWidth(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          this.timer = false;
        }, 400);
      }
    }
  },
  mounted() {
    this.videoUrl = this.catlist[0];
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
    this.getCategory();
  }
};
</script>

<style scoped lang="less">
.cases {
  background-color: #fff;
  .inner-box {
    display: flex;
    // justify-content: space-between;
    // 左侧导航条
    .el-menu-vertical {
      .side {
        display: inline-block;
        height: 33px;
        width: 6px;
        margin-left: -30px;
        margin-right: 10px;
      }
      .side-active {
        background-color: #0e6cb6;
      }
    }
    .el-menu {
      // width: 14%;
      background-color: transparent;
      border-right: none;
    }
    /deep/.el-submenu__title:hover {
      background-color: transparent;
    }
    // .el-submenu {
    //   min-width: 160px;
    // }
    .el-submenu .el-menu-item {
      min-width: auto;
      // font-size: 18px;
      text-align: center;
      // padding-right: 20px;
      // padding-left: 20px !important;
    }
    .el-menu-item:hover {
      background-color: transparent;
      color: #0e6cb6;
    }
    .el-menu-item.is-active {
      color: #0e6cb6;
      background-color: #e3eaf0;
    }
    .all-modules {
      // width: 80%;
      width: 100%;
      padding-left: 6%;
      text-align: center;
      // #player {
      //   width: 100%;
      // }
      .explain {
        margin-top: 2vh;
        line-height: 27px;
        letter-spacing: 1px;
        text-align: left;
        text-indent: 36px;
        text-align: justify;
      }
    }
    // .el-menu-item {
    //   font-size: 24px;
    //   line-height: 33px;
    //   height: 0;
    //   padding-left: 0!important;
    //   margin-bottom: 52px;
    // }
    // .el-menu-item.is-active {
    //   color: #0e6cb6;
    // }
    // .el-menu-item:focus,
    // .el-menu-item:hover {
    //   background-color: transparent;
    // }
  }
  .phone-box {
    .categoryLists {
      .per-category {
        &:hover {
          img {
            transform: scale(1.2);
          }
        }
      }
      .picbox {
        width: 100%;
        overflow: hidden;
        border-radius: 6px;
        height: 38vw;
        img {
          transition: all 0.5s ease;
          width: 100%;
          height: 100%;
        }
      }
      p {
        line-height: 1.375;
        font-size: 16px;
        font-weight: 500;
        padding: 14px 0 34px;
        i {
          padding-left: 3px;
        }
      }
    }
    /deep/.el-tabs__item {
      font-size: 16px;
    }
    /deep/.el-tabs__item:hover {
      color: #fff;
    }
    /deep/.el-tabs__item.is-active {
      background-color: #0e6cb6;
      color: #fff;
      transition: all 0.5s ease;
    }
    /deep/.el-tabs__active-bar {
      background-color: transparent;
    }
    /deep/.el-tabs--top .el-tabs__item.is-top:last-child {
      padding-right: 20px;
    }
    /deep/.el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      padding-left: 20px;
    }
  }
}
@media screen and (min-width: 1200px) {
  /deep/.el-submenu__title {
    font-size: 24px;
  }
  .el-submenu {
    min-width: 160px;
    .el-menu-item {
      font-size: 18px;
      padding-right: 20px;
      padding-left: 20px !important;
    }
  }
  .explain {
    font-size: 18px;
    line-height: 24px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
  //ipad pro
  /deep/.el-submenu__title {
    font-size: 20px;
  }
  .el-submenu {
    min-width: 140px;
    .el-menu-item {
      font-size: 16px;
      padding-right: 16px;
      padding-left: 16px !important;
    }
  }
  .explain {
    font-size: 16px;
    line-height: 30px;
  }
}
@media screen and (min-width: 414px) and (max-width: 768px) {
  //ipad
  /deep/.el-submenu__title {
    font-size: 17px;
  }
  .el-submenu {
    min-width: 120px;
    .el-menu-item {
      font-size: 14px;
      padding-right: 10px;
      padding-left: 10px !important;
    }
  }

  .explain {
    font-size: 14px;
    line-height: 20px;
  }
}
@media screen and (max-width: 414px) {
  //phone
  /deep/.el-submenu__title {
    font-size: 16px;
  }
  .el-submenu {
    min-width: 90px;
    .el-menu-item {
      font-size: 13px;
      padding-right: 0px;
      padding-left: 0px !important;
    }
  }

  .explain {
    font-size: 13px;
    line-height: 16px;
  }
}
</style>
